import {
  CONFIRMED_GET_ANUPANS,
  CONFIRMED_CREATE_ANUPAN,
  CONFIRMED_EDIT_ANUPAN,
  CONFIRMED_DELETE_ANUPAN,
} from "../types/AnupanTypes";

const initialState = {
  list: [],
  num_rows: 0,
};

export default function AnupanReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_ANUPANS:
      return {
        ...state,
        list: action.payload.list,
        num_rows: action.payload.num_rows,
      };

    case CONFIRMED_CREATE_ANUPAN:
      return {
        ...state,
        list: [...state.list, action.payload],
      };

    case CONFIRMED_EDIT_ANUPAN:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
      };

    case CONFIRMED_DELETE_ANUPAN:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== action.payload.anupana_id),
      };

    default:
      return state;
  }
}
